import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { database } from 'firebase';

export class FirebaseJoinService {
  list: FirebaseListObservable<any[]>;
  refList: FirebaseListObservable<any[]>;

  constructor(protected db: AngularFireDatabase, private url: string, refUrl: string) {
    this.list = db.list(url);
    this.refList = db.list(refUrl);
  }

  readList(key: string, fieldName?: string, options?): FirebaseListObservable<any> {
    return this.readChild(key, options).map(list => list.map(item => this.readField(item, fieldName))) as FirebaseListObservable<any>;
  }

  readChild(key: string, options?): FirebaseListObservable<any> {
    return this.db.list(`${this.url}/${key}`, options);
  }

  readChildAsObject(key: string, options?): FirebaseObjectObservable<any> {
    return this.db.object(`${this.url}/${key}`, options);
  }

  readRef(key: string, refKey: string, options?): FirebaseObjectObservable<any> {
    return this.db.object(`${this.url}/${key}/${refKey}`, options);
  }

  private readField(object, field?: string) {
    object[field || '$data'] = this.db.object(this.getRef(object.$key, field));
    return object;
  }

  private getRef(key?: string, field?: string): database.Reference {
    let ref = this.refList.$ref.ref;
    ref = key ? ref.child(key) : ref;
    ref = field ? ref.child(field) : ref;
    return ref;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/firebase/firebase-join-service.ts